/* eslint-disable no-console, react-hooks/exhaustive-deps, sonarjs/cognitive-complexity, complexity, react/prop-types */
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useContext, useState, useRef } from 'react';
import Cookies from 'react-cookies';
import { isMobileOnly } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import VipBanner from '../../components/VipBanner';
import { WellnessBanner } from '../../components/WellnessHeader';
import { logToSplunk } from '../../components/_generic/axiosSplunk/axiosSplunk';
import Spinner from '../../components/_generic/spinner/Spinner';
import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import FacetedNavigationContainer from '../../components/category/FacetedNavigationContainer';
import BottomDeals from '../../components/deal/BottomDeals';
import ConnectedBottomDeals, {
  LAYOUT_TYPES,
} from '../../components/deal/ConnectedBottomDeals';
import {
  dealsGetKeyGenerator,
  fetchDeals,
  getLocationFromSiteID,
} from '../../components/deal/ConnectedBottomDeals/helpers';
import MainDeal from '../../components/deal/MainDeal';
import MediumDeal from '../../components/deal/MediumDeal';
import TrustBox from '../../components/deal/TrustBox';
import InvasiveHealth from '../../components/deal/ihealth/InvasiveHealth';
import NewDeal from '../../components/deal/shared-components/NewDeal';
import RichSnippets from '../../components/deal/shared-components/RichSnippets';
import { DEAL_TYPES } from '../../config/constants/deal-types';
import { VIP_BG } from '../../config/constants/images';
import { PAGE_TYPES, VIP_QUALIFIERS } from '../../config/constants/page-types';
import COOKIES from '../../config/cookies/cookies';
import {
  DESKTOP_PAGE_SIZE,
  LINKS_GLOBAL_PAYPAL,
} from '../../config/links/links';
import {
  BRAND_WOWCHER,
  NUMBER_OF_SECONDARY_DEALS_ON_DEAL,
  TIMEOUT_CHECK_NOT_FOUND,
  PAGE_CACHE_AGE_SEC,
  SITE_LIVINGSOCIAL_IE,
  NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL,
  NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL_TRAVEL,
  SITE_WOWCHERIE,
} from '../../config/setup/setup';
import {
  NO_PREVIEW_DEAL,
  PREVIEW_DEAL,
  TITLE_INDEX,
  TYPE_CATEGORY_DEAL,
} from '../../config/text/text';
import {
  trackPage,
  trackEvent,
  updateDod,
  isOspValid,
} from '../../helpers/analytics';
import { isBotRequest, isLightPage } from '../../helpers/browser';
import {
  getDealPointsData,
  updateLocalStorageDeals,
  getStorageData,
} from '../../helpers/clubWowcher';
import { cookiefbInit, cookieItoInit } from '../../helpers/cookieSetter';
import {
  getEvergreenPageInfo,
  isClosedDeal,
  isProductPageInValid,
  isRedirectDeal,
  isRedirectNumberLastInSlug,
} from '../../helpers/deals';
import ErrorTrackingService from '../../helpers/errorTrackingService';
import { PAGE_DECREMENT_ADJUSTMENT } from '../../helpers/infiniteScroll';
import {
  storeDealIdByCategory,
  storeMainDeal,
} from '../../helpers/recentlyViewed';
import { useSponsoredDealTrackingFromAngular } from '../../helpers/sponsoredSearch';
import { parseWowcherPath } from '../../helpers/url';
import DealsLayout from '../../layouts/DealsLayout';
import ThemeContext from '../../providers/ThemeProvider';
import {
  getClientSideDeal,
  getClientSideDealPreview,
  getClientSideDeals,
  getClientSideRecommendedDeals,
} from '../../redux/actions/clientRender';
import { getGifting } from '../../redux/actions/giftting';
import {
  getServerSideEssentials,
  getServerSideDeal,
} from '../../redux/actions/ssr';
import { LOADING_STATUS } from '../../redux/reducers/loading';
import { wrapper } from '../../redux/store/store';
import { sendViewDealPoints } from '../../services/clubWowcher';

const Deal = ({
  dealId,
  errorCode,
  isEmailDeal,
  isEvergreen,
  emailDealLocation,
  productId,
  isPreview,
}) => {
  const theme = useContext(ThemeContext);
  const router = useRouter();
  const dispatch = useDispatch();
  const [
    mainDeal,
    deals,
    secondaryDealsArray,
    recommendedDeals,
    ssr,
    nomoredeals,
    evergreenUrl,
    isDealPreview,
    canonicalurl,
  ] = useSelector((state) => [
    state.deals.mainDeal,
    state.deals.deals,
    state.deals.secondaryDealsArray,
    state.deals.recommendedDeals,
    state.deals.ssr,
    state.deals.nomore,
    state.deals.evergreenUrl,
    state.deals.isDealPreview,
    state.deals.canonicalUrl || '',
  ]);
  const isSoldOut = isClosedDeal(mainDeal, router.query, router.pathname);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const expressLoading = useSelector((state) => state.profile.status);
  const loadingMessage = useSelector((state) => state.profile.message);
  const location = useSelector((state) => state.locations.location);
  const [pageNotFound, setPageNotFound] = useState(false);
  const [previousAsPath, setRouterAsPath] = useState('');
  const [previewMessage, setPreviewMessage] = useState('');
  const [secondaryDeals, setSecondaryDeals] = useState([]);
  const [productPageId, setProductPageId] = useState(productId);
  const [filteredProduct, setFilteredProduct] = useState(null);
  const [pdtUrl, setPdtUrl] = useState(null);
  const overrideOffset =
    isMobileOnly &&
    (process.env.NEXT_PUBLIC_SITE !== SITE_LIVINGSOCIAL_IE ||
      process.env.NEXT_PUBLIC_SITE !== SITE_WOWCHERIE)
      ? 0
      : null;
  const lastPage = useRef(0);
  const pageInitial = useRef(0);
  const noMoreDealsData = useRef(false);
  const updateNoMoreDeals = (defaultValue = 0) => {
    noMoreDealsData.current = defaultValue;
  };
  const updateInitialPage = (defaultValue = 0) => {
    pageInitial.current = defaultValue;
  };

  const pathUrl = parseWowcherPath(router.asPath);
  const { details, pathArray } = pathUrl;
  const isVipHubDealPage = VIP_QUALIFIERS.includes(pathUrl.pageType);

  const isWellnessPage = details.localDealLocation === PAGE_TYPES.wellness;

  const sideDealsLocal = mainDeal?.display?.sideDealsLocal;
  const v5_ab =
    Cookies.load(COOKIES.v5_ab) === 'BB' ||
    Cookies.load(COOKIES.v5_ab) === 'BA';

  // We have to set ITO cookie here as we need DealID for all deals including Evergreen
  // For evergreen deals we can not get the DealID from UL, only from BE
  // We set the cookie before we call BE to get dynamic prices
  useEffect(() => {
    cookieItoInit(dealId);
    if (router.asPath) {
      cookiefbInit(router.asPath);
    }
  }, [router.asPath, dealId]);

  useEffect(() => {
    if (
      isMobileOnly &&
      !v5_ab &&
      process.env.NEXT_PUBLIC_SITE !== SITE_LIVINGSOCIAL_IE &&
      process.env.NEXT_PUBLIC_SITE !== SITE_WOWCHERIE
    ) {
      setSecondaryDeals(recommendedDeals);
    } else {
      setSecondaryDeals(secondaryDealsArray);
    }
  }, [secondaryDealsArray, recommendedDeals]);

  useEffect(() => {
    const isPayPalScriptLoaded = sessionStorage.getItem('isPayPalScriptLoaded');

    if (!isPayPalScriptLoaded) {
      const loadPaypalScript = () => {
        return new Promise((resolve, reject) => {
          try {
            if (document.cookie.match(`${COOKIES.lightPage}=true`)) {
              resolve();

              return;
            }
            const paypalScript = document.createElement('script');
            paypalScript.defer = true;
            paypalScript.setAttribute('data-namespace', 'PayPalSDK');
            paypalScript.src = `https://www.paypal.com/sdk/js?client-id=${
              LINKS_GLOBAL_PAYPAL[process.env.NEXT_PUBLIC_ENVIRONMENT || 'dev']
            }&currency=GBP&components=messages`;

            paypalScript.onload = () => {
              sessionStorage.setItem('isPayPalScriptLoaded', true);
              resolve();
            };
            paypalScript.onerror = reject;
            document.body.appendChild(paypalScript);
          } catch (error) {
            console.error('Error loading PayPal script:', error);
            reject(error);
          }
        });
      };

      loadPaypalScript().catch((error) => {
        console.error('Error loading PayPal script:', error);
      });
    }

    const cleanup = () => {
      sessionStorage.removeItem('isPayPalScriptLoaded');
    };
    window.addEventListener('beforeunload', cleanup);

    return () => {
      window.removeEventListener('beforeunload', cleanup);
    };
  }, []);

  useEffect(() => {
    async function fetchClientSideDealsAndPreviewDeal() {
      await dispatch(
        getClientSideDeals({
          emailDealLocation,
          isEmailDeal,
          isPreview: true,
          pageSize: details.isTravel
            ? NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL_TRAVEL
            : NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL,
          path: router.asPath,
          query: {
            ...router.query,
          },
          secondaryDealsCount: NUMBER_OF_SECONDARY_DEALS_ON_DEAL,
          sideDealsLocal,
        }),
      );
      updateInitialPage(0);
      dispatch(getClientSideDealPreview(router.query.dealPreview));
    }

    if (previousAsPath === router.asPath.split('?')[0].toLowerCase()) {
      // we ignore if only the parameters are differents
      return;
    }

    setRouterAsPath(router.asPath.split('?')[0].toLowerCase());
    if (
      !isPreview &&
      !errorCode &&
      mainDeal &&
      Object.keys(mainDeal).length !== 0
    ) {
      trackPage(
        {
          dealData: mainDeal,
          dealId: mainDeal.id,
          dealLocation: router.query.slug[0],
          dealType: mainDeal?.display?.dynamicTravelDeal
            ? DEAL_TYPES.channelManager
            : DEAL_TYPES.default,
          location: { name: location.name, shortName: location.shortName },
          products: `;${mainDeal.id};;`,
        },
        details.isTravel ? PAGE_TYPES.travel : PAGE_TYPES.deal,
      );

      const page = new URLSearchParams(window.location.search).get('page');
      // This is called again due to the dynamic pricing on the splat
      dispatch(
        getClientSideDeal({
          byPassSSR: false,
          dealId: dealId || mainDeal.id,
          emailDealLocation,
          isEmailDeal,
          pageSize: details.isTravel
            ? NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL_TRAVEL
            : NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL,
          path: router.asPath,
          query: { ...router.query, page },
          // this is used for redux secondary deals - we wont need this for offset
          secondaryDealsCount: NUMBER_OF_SECONDARY_DEALS_ON_DEAL,

          sideDealsLocal,
        }),
      );

      if (
        !v5_ab &&
        isMobileOnly &&
        (process.env.NEXT_PUBLIC_SITE !== SITE_LIVINGSOCIAL_IE ||
          process.env.NEXT_PUBLIC_SITE !== SITE_WOWCHERIE)
      ) {
        dispatch(getClientSideRecommendedDeals());
      }
      updateInitialPage(0);
    } else {
      trackEvent('page_view');
    }

    if (isPreview && !errorCode) {
      fetchClientSideDealsAndPreviewDeal();
    }
  }, [router.asPath, mainDeal, location]);

  useEffect(() => {
    setTimeout(() => {
      if (
        errorCode ||
        (!ssr &&
          (!mainDeal || Object.keys(mainDeal).length === 0) &&
          (!deals || deals.length === 0))
      ) {
        setPageNotFound(true);
      }
    }, TIMEOUT_CHECK_NOT_FOUND);
  }, [ssr]);

  useEffect(() => {
    if (nomoredeals === noMoreDealsData.current) return;
    updateNoMoreDeals(nomoredeals);
  }, [nomoredeals]);

  useEffect(() => {
    if (isBotRequest(window.navigator.userAgent)) {
      logToSplunk({
        client: 'true',
        description: 'Bot calls deal page client',
        path: router?.asPath,
        referrer: document?.referrer || '',
        server: 'false',
        userAgent: window.navigator.userAgent,
      });
    }
    // Get GiftWrap info
    dispatch(getGifting());
    const queryAux = new URLSearchParams(window.location.search);
    const page = queryAux.has('page')
      ? Number.parseInt(queryAux.get('page'), 10) - PAGE_DECREMENT_ADJUSTMENT
      : 0;
    pageInitial.current = page;
    lastPage.current = page;
  }, []);

  useSponsoredDealTrackingFromAngular(mainDeal.id);

  useEffect(() => {
    const currentDealId = Number(dealId || mainDeal.id);

    const { asPath } = router;
    const hasDealPoints =
      currentDealId && !isSoldOut && !asPath.includes('dealPreview');

    const viewDealsData = getStorageData('viewDealData');
    const shareDealsData = getStorageData('shareDealData');

    const isDealInLocalStorage = viewDealsData?.find(
      (deal) => deal.id === currentDealId,
    );

    const isShareInLocalStorage = shareDealsData?.find(
      (deal) => deal.id === currentDealId,
    );

    if (
      isAuthenticated &&
      hasDealPoints &&
      (!isDealInLocalStorage || !isShareInLocalStorage)
    ) {
      const dealPointsData = getDealPointsData(
        'viewDealData',
        '',
        currentDealId,
        location.shortName,
      );

      sendViewDealPoints(dealPointsData);
    }

    if (!isAuthenticated && hasDealPoints) {
      updateLocalStorageDeals(
        'viewDealData',
        currentDealId,
        location.shortName,
      );
    }
  }, [
    router,
    dealId,
    mainDeal,
    location.shortName,
    isAuthenticated,
    isSoldOut,
  ]);

  useEffect(() => {
    if (isOspValid()) {
      const pageTrackingData = deals;
      if (pageTrackingData) {
        const noOfSimilarDeals = pageTrackingData.reduce(
          (count, currentValue) => {
            return (
              count + (currentValue.isSimilarRecommendedDeal === true ? 1 : 0)
            );
          },
          0,
        );

        const noOfPersonalisedDeals = pageTrackingData.reduce(
          (count, currentValue) => {
            return (
              count +
              (currentValue.isPersonalisedRecommendedDeal === true ? 1 : 0)
            );
          },
          0,
        );

        updateDod({ noOfPersonalisedDeals, noOfSimilarDeals });
      }
    }
  }, [deals]);

  useEffect(() => {
    if (mainDeal.id > 0) {
      storeMainDeal(mainDeal.id);
    }
  }, [mainDeal]);

  useEffect(() => {
    if (isPreview) {
      setPreviewMessage(isDealPreview ? PREVIEW_DEAL : NO_PREVIEW_DEAL);
    }
  }, [isDealPreview]);

  if (pageNotFound) {
    // Import only if needed
    const DynamicComponent = dynamic(() =>
      import('../../components/errors/Form404Block'),
    );

    return <DynamicComponent statusCode={404} />;
  }

  if (typeof window !== 'undefined') {
    window.__CWVL = details.isTravel ? 'travelPage' : 'dealPage';
  }

  useEffect(() => {
    if (productPageId) {
      const path = router.asPath;
      const newPath = path.split('?')[0];
      setPdtUrl(`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${newPath}`);
      setFilteredProduct(
        mainDeal?.products?.find(
          (product) => product.id === Number.parseInt(productPageId),
        ),
      );
    }

    storeDealIdByCategory(mainDeal.id);
  }, []);

  return (
    <div className="deal-page container-wrapper">
      {!isPreview && (
        <RichSnippets
          deal={mainDeal}
          pdtUrl={pdtUrl}
          productDetails={filteredProduct}
          productId={productPageId}
        />
      )}
      <TrustBox />
      <div className="container">
        <VipBanner />
        {expressLoading === LOADING_STATUS.LOADING && (
          <Spinner hasMsg isFullScreen msgText={loadingMessage} />
        )}
        <div className="breadcrumbs item">
          <BreadCrumb deal={mainDeal} />
        </div>

        <div className="row cols main-deal-wrapper">
          {isWellnessPage && <WellnessBanner showTiles={false} theme={theme} />}
          {!details.isTravel && (
            <div className="hero-deals main-deal-item item">
              <InvasiveHealth deal={mainDeal} desktop />
              <div className="cols-display">
                {secondaryDeals.map((deal) => {
                  return <MediumDeal deal={deal} key={deal.id} />;
                })}
              </div>
            </div>
          )}
          <div
            className={classNames(
              {
                'main-deal': !details.isTravel,
                'main-deal-travel': details.isTravel,
              },
              'main-deal-item',
              'item',
            )}
          >
            <MainDeal
              isPreview={isPreview}
              key={mainDeal.id}
              previewMessage={previewMessage}
              productId={productPageId}
              setFilteredProduct={setFilteredProduct}
              setPdtUrl={setPdtUrl}
              setProductPageId={setProductPageId}
            />
            {!isPreview && isSoldOut && !isEvergreen && !details.isTravel && (
              <NewDeal />
            )}
            {!isPreview && <FacetedNavigationContainer isDealPage />}
          </div>
        </div>
        {!isLightPage() && details.isTravel && (
          <ConnectedBottomDeals
            fetcherFunction={fetchDeals}
            getKeyGenerator={dealsGetKeyGenerator({
              emailDealLocation,
              evergreenDealId: isPreview ? null : mainDeal.id,
              firstPageSize: NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL_TRAVEL,
              hasSoldOutMainDeal: isSoldOut,
              isEmailDeal,
              isTravelDeal: true,
              overrideOffset: 0,
              pageSize: DESKTOP_PAGE_SIZE,
              sideDealsLocal,
            })}
            numberSecondaryDeals={0}
            pageSize={DESKTOP_PAGE_SIZE}
            templateType={LAYOUT_TYPES.twoByTwo}
          />
        )}
      </div>
      {!isLightPage() && !details.isTravel && (
        <ConnectedBottomDeals
          fetcherFunction={fetchDeals}
          firstPageSize={NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL}
          getKeyGenerator={dealsGetKeyGenerator({
            emailDealLocation,
            evergreenDealId: isPreview ? null : mainDeal.id,
            firstPageSize: NUMBER_OF_DEALS_FIRST_PAGE_ON_DEAL,
            hasSoldOutMainDeal: isSoldOut,
            isEmailDeal,
            overrideOffset,
            pageSize: DESKTOP_PAGE_SIZE,
            sideDealsLocal,
          })}
          numberSecondaryDeals={NUMBER_OF_SECONDARY_DEALS_ON_DEAL}
          pageSize={DESKTOP_PAGE_SIZE}
        />
      )}
      {ssr && (
        <BottomDeals
          deals={isSoldOut ? deals.slice(1) : deals}
          pageInitial={pageInitial.current}
        />
      )}
      <style jsx>{`
        .deal-page {
          padding-top: 0;
          padding-bottom: 60px;
          background: ${isVipHubDealPage ? `url(${VIP_BG})` : 'none'};
        }
        .main-deal-wrapper {
          width: 100%;
        }
        .cols-display {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
        }
        .row-display {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .breadcrumbs {
          display: none;
          margin: 0 auto 20px;
          text-align: left;
        }
        .cols {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .hero-deals {
          width: 353.33px;
        }
        .main-deal {
          width: 727px;
        }
        .main-deal-travel {
          width: 100%;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .breadcrumbs {
            display: block;
            margin-top: 16px;
            width: 100%;
          }
          .deal-page {
            padding-top: 0;
          }
        }

        @media (min-width: ${theme.breakpoints.mdUp}) {
          .main-deal-wrapper {
            margin-bottom: 20px;
          }
          .breadcrumbs {
            max-width: ${details.isTravel ? '100%' : '666px'};
          }
          .cols-display {
            margin-bottom: 20px;
          }
        }

        @media (min-width: ${theme.breakpoints.xlUp}) {
          .cols-display {
            flex-direction: column;
          }
          .breadcrumbs {
            max-width: 100%;
          }
        }

        // iPad
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .hero-deals {
            width: 666px;
            margin: 0 auto;
          }
          .main-deal-wrapper .hero-deals {
            order: 2;
          }
          .main-deal-wrapper .main-deal {
            margin: 0 auto;
            width: 666px;
          }
        } // 1199

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .container {
            padding: 0px;
          }
          .row {
            padding-left: 0px;
            padding-right: 0px;
            margin-left: 0px;
            margin-right: 0px;
          }
          .main-deal-wrapper .main-deal {
            width: 100%;
          }
          .main-deal-wrapper .main-deal-item {
          }
          .main-deal-wrapper .main-deal {
            order: 1;
          }
          .main-deal-wrapper .hero-deals {
            order: 4;
            width: 566px;
          }
          .deal {
            height: 300px !important;
            width: 100%;
          }
        }
      `}</style>

      <style global jsx>{`
        html,
        body {
          padding: 0;
          margin: 0;
        }

        * {
          box-sizing: border-box;
        }

        .deal-page .hero-deals .medium-deal {
          margin-bottom: 20px;
        }

        .container-wrapper {
          min-height: 100vh;
        }
        .container-wrapper .container {
          padding: 0 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .container-wrapper .container {
          width: ${details.isTravel ? '1280px' : '1110px'};
        }

        .bottom-deals .card.xl-deal {
          margin-top: 0 !important;
        }

        @media (min-width: ${theme.breakpoints.xlUp}) {
          .bottom-deals .card.xl-deal {
            margin-top: 20px !important;
          }
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          // 768
          .container-wrapper .container {
            width: 668px;
          }
        } // 728

        @media (max-width: ${theme.breakpoints.smDown}) {
          //575
          .container-wrapper .container {
            width: 100%;
            max-width: 100%;
            padding: 0;
            margin: 0;
          }

          .cols-display .ipad-row {
            width: 100% !important;
          }
          .deal-page .hero-deals .medium-deal {
            margin-bottom: 5px;
          }
        } //575
      `}</style>
    </div>
  );
};

const showErrorPage = () => ({ props: { errorCode: true } });

export const getParameters = async (
  dealId,
  request,
  query,
  isEvergreen,
  emailDealLocation = null,
  isEmailDeal = false,
  // eslint-disable-next-line max-params
) => {
  if (isEvergreen) {
    try {
      const [location, category, subCategory, , dealName] = query.slug;
      const eg = await getEvergreenPageInfo({
        category,
        dealName,
        location,
        subCategory,
      });

      const slug = [eg.location, eg.category, eg.subCategory, eg.dealId];

      // pass the evergreen deal id - and slug params probably not needed any more
      return {
        dealId: eg.dealId,
        emailDealLocation,
        isEmailDeal,
        path: request.url,
        query: { ...query, slug },
      };
    } catch (error) {
      console.log(`getEvergreenData error: ${error}`);
      ErrorTrackingService.logError(error);

      return showErrorPage();
    }
  } else {
    // normal pages
    return {
      dealId,
      emailDealLocation,
      isEmailDeal,
      path: request.url,
      query,
      // this is used for redux secondary deals - we wont need this for offset
      secondaryDealsCount: NUMBER_OF_SECONDARY_DEALS_ON_DEAL,
    };
  }
};

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ store, req, res, query }) => {
    const isEvergreen = query.slug.includes('e');
    const isEmailDeal = req?.url.includes('?site=');
    let emailDealLocation = null;

    const dealIdIndex = query.slug.findIndex((item) => /^\d+$/.test(item));
    const productIdIndex = query.slug.findIndex(
      (item, index) => index !== dealIdIndex && /^\d+$/.test(item),
    );

    const dealId = dealIdIndex !== -1 ? query.slug[dealIdIndex] : null;
    const productId = productIdIndex !== -1 ? query.slug[productIdIndex] : null;

    if (isEmailDeal) {
      // fetch the siteID from the url
      const [, queryString] = req.url.split(/\?|#/g);
      const searchParameters = new URLSearchParams(queryString);
      const siteID = searchParameters.get('site');
      emailDealLocation = await getLocationFromSiteID(siteID);
    }

    if (isBotRequest(req.headers['user-agent'])) {
      logToSplunk({
        client: 'false',
        description: 'Bot calls deal page server',
        path: req?.url,
        referrer: req?.headers?.referer,
        requestHeaders: req?.headers,
        server: 'true',
        userAgent: req.headers['user-agent'],
      });
    }

    // deal preview - was redirected here from next.config
    if (dealId === '1111111111111111') {
      await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
        console.log(`getServerSideEssentials , slug deal page: ${error}`);
        ErrorTrackingService.logError(error);
      });

      return { props: { isPreview: true, url: req.url } };
    }

    if (!dealId && !isEvergreen) {
      return {
        notFound: true,
      };
    }

    // modify query params if params are related to evergreen
    const parameters = await getParameters(
      dealId,
      req,
      query,
      isEvergreen,
      emailDealLocation,
      isEmailDeal,
    );

    // core, page, products, navigation
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.log(`getServerSideEssentials , slug deal page: ${error}`);
      ErrorTrackingService.logError(error);
    });

    // deal page
    await store.dispatch(getServerSideDeal(parameters)).catch((error) => {
      // console.log only visible in Server Side
      console.log(`getServerSideDeal error: ${error}`);
      ErrorTrackingService.logError(error);
    });
    const { deals } = store.getState();

    if (!Object.keys(deals?.mainDeal ?? {}).length) {
      return {
        notFound: true,
      };
    }

    const mainDeal = deals.mainDeal;
    const { chainDealId, chainDealUrlPrefix, toUrl, dealPrefix } = mainDeal;
    const { evergreenUrl, redirectUrl, canonicalUrl } = deals;
    const cat = mainDeal.category.feCategoryShortName;
    const subcat = mainDeal.subCategory.shortName;
    const isDisableRedirect = query?.reload === 'disable';
    const isMainDealExpired = !mainDeal.open || mainDeal.soldOut;
    const additionalParameters = req?.url?.split('?')[1] || '';
    const filteredParameters = additionalParameters
      .split('&')
      .filter((parameter) => !parameter.includes('slug'))
      .join('&');
    const productExists = mainDeal?.products?.some(
      (product) => product.id === Number.parseInt(productId),
    );

    // Evergreen main redirect, not if already on an evergreen url
    if (!isEvergreen && evergreenUrl && productId && !productExists) {
      res.setHeader(
        'Cache-Control',
        `no-cache, no-store, max-age=0, must-revalidate`,
      );

      return {
        redirect: {
          destination: `${evergreenUrl}${
            filteredParameters ? '?' + filteredParameters : ''
          }`,
          statusCode: 301,
        },
      };
    }

    // Evergreen additional redirects, deal must be expired
    if (!isEvergreen && !evergreenUrl && redirectUrl && isMainDealExpired) {
      res.setHeader(
        'Cache-Control',
        `no-cache, no-store, max-age=0, must-revalidate`,
      );

      return {
        redirect: {
          destination: `${redirectUrl}${
            filteredParameters ? '?' + filteredParameters : ''
          }`,
          statusCode: 301,
        },
      };
    }

    if (!isEvergreen && toUrl && !isDisableRedirect) {
      return {
        redirect: {
          destination: `${toUrl}`,
          statusCode: 301,
        },
      };
    } else if (
      // Chaining redirect
      !isEvergreen &&
      !evergreenUrl &&
      !redirectUrl &&
      chainDealId &&
      chainDealUrlPrefix &&
      !isDisableRedirect
    ) {
      res.setHeader(
        'Cache-Control',
        `no-cache, no-store, max-age=0, must-revalidate`,
      );
      const originalDealUrl = req.url;
      const chainedDealUrl = originalDealUrl
        .replace(mainDeal.id, chainDealId)
        .replace(mainDeal.dealPrefix, chainDealUrlPrefix);

      // adding from param to the query string so that a redirection notice can be displayed
      return {
        redirect: {
          destination: `${chainedDealUrl}${
            chainedDealUrl.includes('?') ? '&' : '?'
          }from=${mainDeal.id}`,
          statusCode: 301,
        },
      };
    }

    // Non canonical url redirect
    if (
      !isEvergreen &&
      !evergreenUrl &&
      (isRedirectDeal(mainDeal, req.url, productId) ||
        isRedirectNumberLastInSlug(query.slug, canonicalUrl))
    ) {
      return {
        redirect: {
          destination: `${canonicalUrl}${
            filteredParameters ? '?' : ''
          }${filteredParameters}`,
          statusCode: 301,
        },
      };
    }

    const isNationalDeal = query?.slug[0] === 'shop';
    if (
      productId &&
      isProductPageInValid(
        mainDeal,
        productId,
        dealIdIndex,
        productIdIndex,
        isEvergreen,
        isNationalDeal,
      )
    ) {
      return {
        notFound: true,
      };
    }

    res.setHeader('Cache-Control', `public, max-age=${PAGE_CACHE_AGE_SEC}`);

    return {
      props: {
        dealId: isEvergreen ? parameters.dealId : dealId,
        emailDealLocation,
        isEmailDeal,
        isEvergreen,
        productId,
        url: req.url,
      },
    };
  },
);

// Change the page title
Deal.title = TITLE_INDEX[process.env.NEXT_PUBLIC_BRAND || BRAND_WOWCHER];
Deal.titletype = TYPE_CATEGORY_DEAL;
Deal.layout = DealsLayout;
// Show the counterdown timer
Deal.countdown = false;

Deal.propTypes = {
  dealId: PropTypes.string,
  errorCode: PropTypes.bool,
  isEvergreen: PropTypes.bool,
  isPreview: PropTypes.bool,
};

export default Deal;
